import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ChromePicker } from 'react-color';
import { useResume } from '../../context/ResumeContext';
import { FONT_FAMILIES, FONT_SIZES, MEMBERSHIP, PAID_SERVICES, POPUP_TYPES, DEFAULT_VARIANT_COLOR, DEFAULT_TEMPLATE_COLOR, OLD_COLOR_CODES, COVERLETTER_EXPERIENCE, APP_DOMAIN } from '../../constants/constants';
import Resumes from '../resumetemplates/Resumes';
import downloadResume from '../../downloadResume';
import { usePopup } from '../../context/PopupContext';
import WpAPI from '../../WpApi';
import SignUpPopup from '../user/SignUpPopup';
import RainblowPicker from '../../assets/images/ranbow-02.svg';
import { userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction } from '../../services/actions/actions';
import { useUser } from '../../context/UserContext';
const StyleControls = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const popupbox = usePopup();
    const ddRef = useRef();
    const [openFFDropDown, setOpenFFDropDown] = useState(false);
    const [customColor, setCustomColor] = useState('#000000');
    const [spinner, setSpinner] = useState(false);
    const [currIndex, setCurrIndex] = useState();
    const [showLoginPopUp, setShowLoginPopUp] =  useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false});
    const [showColorPicker, setShowColorPicker] = useState(false);

    const {
        checkMembership,
        plan,
        user
    } = useUser();

    const {
        resume,
        setShowPreview,
        handlers: {
            updateResumePreview,
            //nuteralizeNextClick,
            //nuteralizeBackClick,
            onsaveResume,
            //deleteSection,
        },
        currentResume
    } = useResume();

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    // const setCustomColor = (e) => {
    //     console.log(e);
    // }

    const updateFontFamily = (font_id) => {
        updateResumePreview({ heading_font_family: font_id });
        onsaveResume();
        setOpenFFDropDown(false);
    }
    const updateFontSize = (font_size) => {
        updateResumePreview({ heading_font_size: font_size });
        onsaveResume();
    }

    const updateCustomColor = (color) => {
        updateResumePreview({ heading_color: color });
        onsaveResume();
    }
    const decreaseFontSize = () => {
        let index = getPrevIndex(resume.heading_font_size);
        setCurrIndex(index - 1);
        let fontSize = FONT_SIZES[index];
        updateFontSize(fontSize.id);

    }
    const increaseFontSize = () => {
        let index = getNextIndex(resume.heading_font_size);
        setCurrIndex(index + 1);
        let fontSize = FONT_SIZES[index];
        updateFontSize(fontSize.id);
    }

    const getPrevIndex = (size) => {
        var index = findIndex(size);
        return (index <= 0 ? 0 : index - 1);
    }
    const getNextIndex = (size) => {
        var index = findIndex(size);
        return (index >= (FONT_SIZES.length - 1) ? (FONT_SIZES.length - 1) : index + 1);;
    }
    const findIndex = (value) => {
        for (let i = 0; i < FONT_SIZES.length; i++) {
            if (FONT_SIZES[i].id == value) {
                return i;
            }
        }
        return -1;
    }
    const onClickOutside = (e) => {
        if (e.target.classList.value != 'block-name') {
            setOpenFFDropDown(false);
        }

        if (e.target.classList.value != '') {
            setShowColorPicker(false);
        }
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ddRef.current && !ddRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    // useEffect(() => {
    //     console.log(resume.heading_color);

    //     if (resume.heading_color != '') {
    //         //setCustomColor(resume.heading_color);
    //     }
    // }, []);

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
        let liveIndex = findIndex(resume.heading_font_size);
        setCurrIndex(liveIndex);

    }, []);

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
        });
    }

    const downloadHandler = (downloadFormat) => {
        downloadResume({resume, currentResume, user}, user, () => { 
            popupbox.close('download'); 
            // popupbox.show('downloadcompletionbox', null, () => {
            //     window.location.href = `${APP_DOMAIN}${COVERLETTER_EXPERIENCE}`;
            // });
        }, downloadFormat, {type: 'resume', name: 'Resume' });
        gaTrack('RT App', `Quick Editor`, 'Header Download');
        ga4Track('app_header_download', 'RT App', 'Header Download');
    }

    const getColorCode = () => {
        if(DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]] == undefined){
            return resume?.heading_color ? 
                resume.heading_color : 
                (resume.custom_template_color ? 
                resume.custom_template_color : 
                (resume.active_color ? 
                DEFAULT_VARIANT_COLOR[resume.active_color]  : 
                DEFAULT_TEMPLATE_COLOR[resume.active_template]));
        } else {
            return resume?.heading_color ? 
                resume.heading_color : 
                (resume.custom_template_color ? 
                resume.custom_template_color : 
                (resume.active_color ? 
                DEFAULT_VARIANT_COLOR[OLD_COLOR_CODES[resume.active_color]]  : 
                DEFAULT_TEMPLATE_COLOR[resume.active_template]));
        }
    }

    const download = () => {
        localStorage.setItem('clickAction', 'download');
        if(WpAPI.isLoggedIn()){
            // if(PAID_SERVICES){
            //     if(plan == 'pro'){
            //         popupbox.show('download', null, () => downloadHandler())
            //     }else history.push(MEMBERSHIP);
            // }else{
            //     popupbox.show('download', null, () => downloadHandler())
            // }
            /**
             * #775: Any logged in users can download the resume in the text format. 
             * Action: Removed the above code snippet having PAID_SERVICES and plan check.
             * Date: 2023-07-21
             */
            popupbox.show('download', null, (params) => {
                downloadHandler(params.downloadFormat);
                userCompletesSectionsDownloadsPrintsOrShares();
                ga4Track('app_header_menu_download', 'RT App', 'Download');
            }, {plan: plan, entity: {type: 'resume', name: 'Resume' }});
        }else{
            setShowLoginPopUp(true);
            WpAPI.setRedirectCookie(location.pathname);
        }
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...resume}, 'currentResume')).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
    }

    return (<div className="header-controls">
        <div className="dropdown-controls">
            <div className="block-dd section-list">
                <div className="block-name-wrap">
                    <span className="block-name"><span className="name">Edit Headers</span>
                        {/* <i className="icon-right-arrow"></i> */}
                    </span>
                    {/* <div className="block-list">
                        <ul>
                            <li>Header</li>
                            <li>Work History</li>
                            <li>Education</li>
                            <li>Skills</li>
                            <li>Additional Sections</li>
                        </ul>
                    </div> */}
                </div>
            </div>
            <div className="block-dd fontfamily-list">
                <div className="block-name-wrap">
                    <span className="block-name" onClick={() => {
                        setOpenFFDropDown(!openFFDropDown);
                    }}>
                        <span className="name">{resume.heading_font_family ? resume.heading_font_family : 'Select Font'}</span>
                        <i className="icon-right-arrow"></i>
                    </span>
                    {openFFDropDown ? <div className="block-list" ref={ddRef}>
                        <ul className="list-1">
                            {FONT_FAMILIES.map((value, index) => {
                                return (
                                    <li 
                                        onClick={(e) => { 
                                            updateFontFamily(value.id);
                                            gaTrack('RT App', `Header Menu`, 'Change Font');
                                            ga4Track('app_header_menu_change_font', 'RT App', 'Change Font');
                                        }} 
                                        key={index}>{value.name}</li>
                                )
                            })}
                        </ul>
                    </div> : ''}
                </div>
            </div>

            <div className="block-dd color-picker-wrap">
                <div className="block-name-wrap">
                    <div className="head-color-picker" onClick={() => {
                        setShowColorPicker(true);
                    }}>
                        <span className="color-picker">
                            {<i className="color-square" style={{ backgroundColor: getColorCode() }}></i>}
                        </span>
                        {showColorPicker ? <div className="chrome-picker" style={{ top: '28px', right: '50%', transform: 'translate(50%, 0px)', position: 'absolute' }} ref={ddRef}>

                            <ChromePicker
                                color={getColorCode()}
                                onChange={(e) => { setCustomColor(e.hex) }}
                                onChangeComplete={(e) => {
                                    updateCustomColor(e.hex);
                                    gaTrack('RT App', `Header Menu`, 'Change Color');
                                    ga4Track('app_header_menu_change_color', 'RT App', 'Change Color');
                                }}
                                disableAlpha={true}
                            />

                        </div> : ''}
                        <span className="color-code">{getColorCode()}</span>
                        {/* <span className="cross" onClick={() => {
                            updateCustomColor('');
                        }}><i className="icon-cross-icon"></i></span> */}
                        {/* <input
                                type="color"
                                name="color"
                                value={resume?.heading_color ? resume.heading_color : DEFAULT_VARIANT_COLOR[resume.active_color]}
                                onChange={(e) => {
                                    updateCustomColor(e.target.value);
                                }} /> */}
                    </div>
                </div>
            </div>

            <div className="block-dd fontsize-list">
                <div className="block-name-wrap">
                    <span className="block-name fs">
                        <span className="minus-fs" onClick={() => {
                            currIndex >= 0 ? decreaseFontSize() : '';
                            if(currIndex >= 0){
                                gaTrack('RT App', `Header Menu`, 'Change Size');
                                ga4Track('app_header_menu_change_size', 'RT App', 'Change Size');
                            }
                        }}  data-acsb-navigable="true">-</span>
                        <span className="name">{resume.heading_font_size ? (resume.heading_font_size).replace('-', ' ') : 'Size'}</span>
                        <span className="plus-fs" onClick={() => {
                            currIndex < FONT_SIZES.length ? increaseFontSize() : '';
                            if(currIndex < FONT_SIZES.length){
                                gaTrack('RT App', `Header Menu`, 'Change Size');
                                ga4Track('app_header_menu_change_size', 'RT App', 'Change Size');
                            }
                        }}   data-acsb-navigable="true">+</span>
                    </span>
                </div>
            </div>
        </div>

        {/* {!props.hidebuttons && <div className="button-link-wrap"> */}
            {/* <div className="button-link" onClick={()=>{setShowPreview(true); ga4Track('app_editor_preview', 'RT App', 'Preview');}} >
                <span className="preview-btn"><i className="icon-eye"></i>Preview</span>
            </div> */}
            {/* <div className="button-link">
                <span className="download-btn">
                    <i className="icon-download-2"></i> Dowload <i className="arrow icon-right-arrow"></i></span>
            </div> */}
            {/* <div className="button-link">
                <span className="download-btn" onClick={() => checkMembershipAction(download)}>
                    <i className="icon-download-2"></i> {loader.download ? 'Loading...' : 'Download'}
                </span>
            </div> */}
        {/* </div> } */}
        {showLoginPopUp && <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} />}
    </div>);
}

export default StyleControls;